// @ts-nocheck legacy file transformed to TS
import styled from '@emotion/styled'
import { FULL_VIEWPORT_HEIGHT, MAIN_NAV_WIDTH } from 'legacy/common/theme'

/**
 * Full height and width container that accounts for the AppHeader and MainNav.
 */

const PageContainer = styled.div`
  width: 100%;
  height: calc(${FULL_VIEWPORT_HEIGHT} - ${MAIN_NAV_WIDTH});
`

export default PageContainer
